export const trackingPixels = [
  { type: "GOOGLE_ANALYTICS", title: "Google Analytics"},
  { type: "GOOGLE_TAG_MANAGER", title: "Google Tag Manager" },
  { type: "FACEBOOK", title: "Facebook" },
  { type: "LINKEDIN", title: "LinkedIn" },
  { type: "MUNCHKIN", title: "Munchkin" }
]